(function () {
    window.KocotAnimations = window.KocotAnimations || {};

    window.KocotAnimations.initImageOverlayAnimations = function () {
        var overlays = document.querySelectorAll('[data-anim="img-mask"]');

        if (!overlays.length) {
            return;
        }

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            overlays.forEach(function (overlay) {
                overlay.classList.add('is-inview');
            });
            return;
        }

        if (!('IntersectionObserver' in window)) {
            overlays.forEach(function (overlay) {
                overlay.classList.add('is-inview');
            });
            return;
        }

        var observer = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (!entry.isIntersecting) {
                    return;
                }

                entry.target.classList.add('is-inview');
                observer.unobserve(entry.target);
            });
        }, {
            rootMargin: '0px 0px -50px 0px',
            threshold: 0,
        });

        overlays.forEach(function (overlay) {
            observer.observe(overlay);
        });
    };
})();
